import { useTranslation } from 'react-i18next';
import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';
import { UsageSectionLabel } from './usage-section-label';

export function UsageLoadingSkeleton() {
  const { t } = useTranslation();

  return (
    <>
      <div className="space-y-4">
        <UsageSectionLabel>{t('OVERVIEW')}</UsageSectionLabel>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(12.5rem,1fr))] gap-3">
          {Array.from({ length: 5 }).map((_, index) => (
            <Card key={index} className="min-w-0 overflow-hidden border-border/70 shadow-none">
              <CardContent className="space-y-3 p-4">
                <Skeleton className="h-3 w-24" />
                <Skeleton className="h-8 w-28" />
                <Skeleton className="h-3 w-20" />
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <UsageSectionLabel>{t('DAILY_USAGE')}</UsageSectionLabel>
        <Card className="border-border/70 shadow-none">
          <CardContent className="space-y-4 p-5 md:p-6">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-[240px] w-full" />
          </CardContent>
        </Card>
      </div>

      <div className="space-y-4">
        <UsageSectionLabel>{t('TOKEN_BREAKDOWN')}</UsageSectionLabel>
        <Card className="border-border/70 shadow-none">
          <CardContent className="space-y-5 p-5 md:p-6">
            <Skeleton className="h-40 w-full rounded-xl" />
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </CardContent>
        </Card>
      </div>

      <div className="grid items-stretch gap-3 xl:grid-cols-2">
        <div className="flex h-full flex-col gap-4">
          <UsageSectionLabel>{t('BY_OPERATION')}</UsageSectionLabel>
          <Card className="flex-1 border-border/70 shadow-none">
            <CardContent className="flex h-full flex-col space-y-5 p-5 md:p-6">
              <Skeleton className="h-8 w-24" />
              <div className="grid gap-6 md:grid-cols-[7rem_minmax(0,1fr)] md:items-start">
                <Skeleton className="h-28 w-28 rounded-full" />
                <div className="flex-1 space-y-3">
                  {Array.from({ length: 3 }).map((_, index) => (
                    <Skeleton key={index} className="h-5 w-full" />
                  ))}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div className="flex h-full flex-col gap-4">
          <UsageSectionLabel>{t('BY_PROVIDER')}</UsageSectionLabel>
          <Card className="flex-1 border-border/70 shadow-none">
            <CardContent className="flex h-full flex-col space-y-5 p-5 md:p-6">
              <Skeleton className="h-8 w-24" />
              <div className="grid gap-6 md:grid-cols-[7rem_minmax(0,1fr)] md:items-start">
                <Skeleton className="h-28 w-28 rounded-full" />
                <div className="flex-1 space-y-3">
                  {Array.from({ length: 4 }).map((_, index) => (
                    <Skeleton key={index} className="h-5 w-full" />
                  ))}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      <div className="space-y-4">
        <UsageSectionLabel>{t('ANALYTICS_PER_MODEL')}</UsageSectionLabel>
        <Card className="border-border/70 shadow-none">
          <CardContent className="space-y-3 p-5 md:p-6">
            <Skeleton className="h-5 w-full" />
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="h-12 w-full" />
            ))}
          </CardContent>
        </Card>
      </div>

      <div className="space-y-4">
        <UsageSectionLabel>{t('TOP_AGENTS')}</UsageSectionLabel>
        <Card className="border-border/70 shadow-none">
          <CardContent className="space-y-3 p-5 md:p-6">
            <Skeleton className="h-5 w-full" />
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="h-12 w-full" />
            ))}
          </CardContent>
        </Card>
      </div>

    </>
  );
}
